import { VendorRentalPage } from "@/features/vendor-app/pages/VendorRentalPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/vendor/rental/")({
	component: VendorRentalPage,
});
